import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const HERO_IMAGE = "https://storage.readdy-site.link/project_files/fa5b628a-f6f7-4c2e-8ec9-0248dc91d24b/e27ea7ee-3997-44ca-94f0-0de49aa572ae_ChatGPT-Image-2026520-18_21_29.png?v=8aba3e5b8af1a58de1831c6634edd719";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative w-full h-[85vh] min-h-[600px] max-h-[900px] overflow-hidden bg-ink"
    >
      <div className="hidden lg:flex absolute right-0 top-0 bottom-0 w-[42%] items-center justify-center">
        <img
          src={HERO_IMAGE}
          alt="Traditional Japanese wooden interior with warm natural light"
          className="max-w-full max-h-full object-contain"
        />
      </div>

      <div className="lg:hidden absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Traditional Japanese wooden interior with warm natural light"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-ink/85 via-ink/55 to-ink/20 lg:hidden"></div>
      <div className="hidden lg:block absolute inset-y-0 left-0 w-[65%] bg-gradient-to-r from-ink via-ink to-ink/70"></div>

      <div className="relative z-10 h-full flex flex-col justify-end lg:justify-center px-4 md:px-8 lg:px-12 pb-12 lg:pb-0 pt-24">
        <div className="max-w-xl">
          <div
            className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            <h1 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] font-medium text-paper leading-[1.08] mb-6">
              {t("hero.title")}{" "}
              <span className="italic font-normal text-paper/80">
                {t("hero.titleItalic")}
              </span>
            </h1>
          </div>

          <div
            className={`w-16 h-px bg-paper/30 mb-6 transition-all duration-700 delay-150 ${visible ? "opacity-100" : "opacity-0"}`}
          ></div>

          <div
            className={`transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            <p className="text-base md:text-lg text-paper/70 leading-relaxed mb-3 max-w-md font-light">
              {t("hero.subtitle")}
            </p>
            <p className="text-sm text-gold font-medium mb-8 tracking-wide">
              {t("hero.pricePoint")}
            </p>
          </div>

          <div
            className={`flex flex-col sm:flex-row gap-3 transition-all duration-700 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            <a
              href="#inquiry"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("inquiry")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center gap-2 bg-paper text-ink text-sm font-medium px-6 py-3 rounded-full hover:bg-gold transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              {t("hero.ctaPrimary")}
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
            <a
              href="#services"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("services")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center gap-2 border border-paper/30 text-paper text-sm font-medium px-6 py-3 rounded-full hover:bg-paper/10 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              {t("hero.ctaSecondary")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}